<template>
    <div style="margin-top: 20px;">
        <template>
            <v-row justify="center">
                <v-dialog v-model="autorizacaoDialog" persistent max-width="500">
                    <v-card>
                        <v-card-title class="headline">
                            <span style="color: #d60000">Mensagem do Sistema</span>
                        </v-card-title>
                        <v-card-text>
                            <span style="color: #d60000">{{ this.mensagemAutorizacaoDialog }}</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red accent-4" class="white--text" @click="logout">Logout</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialogConfirmacaoRoletaQuebra" max-width="480" persistent>
                    <v-card style="color: #d60000;">
                        <v-card-title class="headline">Confirmar roleta</v-card-title>
                        <v-card-text style="color: #d60000;">
                            A leitura da roleta está mais de {{ config?.porcentagem_diferenca_roleta }}% acima da roleta
                            anterior.
                            Deseja confirmar a inclusão desta roleta?
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text style="color: #d60000;"
                                @click="cancelarConfirmacaoRoletaQuebra">Cancelar</v-btn>
                            <v-btn color="#d60000" style="color: white;"
                                @click="confirmarInclusaoRoletaQuebra">Confirmar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>

        <div style="margin-left: 5px; margin-right: 5px;">
            <v-navigation-drawer v-model="showDrawer" absolute temporary overlay-opacity="0" left dark
                style="width: 50%; z-index: 10">
                <v-toolbar flat style="border-radius: 10px; margin-top: 5px">
                    <v-text-field v-model="searchLinhas" append-icon="mdi-magnify" :label="$t('monitor.map.searchLine')"
                        single-line hide-details></v-text-field>
                </v-toolbar>
                <v-toolbar flat style="border-radius: 10px; margin-top: 5px; padding-top: 10px;">
                    <v-autocomplete :items="pontos" v-model="pontoSelected" return-object item-text="nome_cerca"
                        prepend-icon="mdi-map-marker" @change="pontoChanged"></v-autocomplete>
                </v-toolbar>
                <v-list style="height: 35%; overflow-y: auto; margin-top: 10px;">
                    <v-list-item v-for="(linha, l) in linhasFiltered" :key="l" @click="plotOnMap(linha)">
                        <v-list-item-title>{{ linha.nome_rota_longo }}</v-list-item-title>
                        <v-list-item-content></v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <v-list style="height: 20%; overflow-y: auto;" nav>
                    <v-list-item v-for="(veiculo, v) in veiculosSelected" :key="v" @click="openVeiculoDialog(veiculo)">
                        <v-list-item-title>{{ veiculo.numero_ordem }}</v-list-item-title>
                        <v-list-item-content></v-list-item-content>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <div style="color: white; margin-left: 15px; margin-top: 5px"
                    v-if="veiculosSelectedSentidoInvalido.length > 0">
                    {{ $t('monitor.map.outOfTrip') }}</div>
                <v-list style="height: 20%; overflow-y: auto;" nav>
                    <v-list-item v-for="(veiculo, v) in veiculosSelectedSentidoInvalido" :key="v"
                        @click="openVeiculoDialog(veiculo)">
                        <v-list-item-title>{{ veiculo.numero_ordem }}</v-list-item-title>
                        <v-list-item-content></v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>

            <v-dialog v-model="dialogDiarioBordo" fullscreen max-width="100%">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>{{ $t('monitor.logbook.title') }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="closeDiarioBordo">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-card-text>
                        <v-container>
                            <v-form ref="diarioForm">
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete v-model="itemDiario.id_tipo_entrada_diario"
                                            :items="tiposEntradaDiario" item-text="descricao_tipo_entrada"
                                            item-value="id_tipo_entrada_diario" clearable
                                            :label="$t('monitor.logbook.type')" outlined
                                            :rules="[(v) => !!v || $t('monitor.logbook.typeRequired')]"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete v-model="itemDiario.id_motivo" :items="motivos"
                                            item-text="descricao_motivo" item-value="id_motivo" clearable
                                            :label="$t('monitor.logbook.reason')" outlined
                                            :rules="[(v) => !!v || $t('monitor.logbook.reasonRequired')]"></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-datetime-picker :label="$t('monitor.logbook.entryDate')"
                                            v-model="dtEntradaDiario" :time-picker-props="timeProps"
                                            :text-field-props="textFieldProps" time-format="HH:mm:ss"
                                            date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')" outlined
                                            :rules="[(v) => !!v || $t('monitor.logbook.dateRequired')]">
                                            <template slot="dateIcon">
                                                <v-icon>mdi-calendar</v-icon>
                                            </template>
                                            <template slot="timeIcon">
                                                <v-icon>mdi-clock</v-icon>
                                            </template>
                                        </v-datetime-picker>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete v-model="diarioLinhas" :items="linhas" item-text="nome_linha"
                                            item-value="id_linha" clearable multiple outlined
                                            :label="$t('monitor.logbook.line')"
                                            @change="onLinhaDiarioChanged"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete v-model="diarioVeiculos" :items="veiculos"
                                            item-text="numero_ordem" item-value="id_veiculo" clearable multiple outlined
                                            :label="$t('monitor.logbook.vehicle')"
                                            @change="onVeiculoDiarioChanged"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete v-model="diarioViagens" :items="viagensDiarioDialog"
                                            item-text="descricao_viagem" item-value="id_viagem" clearable multiple
                                            outlined :label="$t('monitor.logbook.trip')"></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12">
                                        <v-textarea v-model="itemDiario.observacoes"
                                            :label="$t('monitor.logbook.observations')" auto-grow clearable counter
                                            outlined rows="1"
                                            :rules="[(v) => (v === null || v.length <= 1000) || $t('monitor.logbook.maxCharacters')]"></v-textarea>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12">
                                        <v-btn color="primary" dark class="mb-2" block height="60px"
                                            @click="saveEntrada">
                                            {{ $t('monitor.logbook.saveEntry') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                        <v-container>
                            <v-data-table :headers="headersDiario" :items="entradasDiario" sort-by="dt_entrada" dense
                                class="elevation-7" locale="pt" :loading="loadingDiario" show-expand
                                :single-expand="true" item-key="id_entrada_diario"
                                :loading-text="$t('monitor.map.loading')" style="border-radius: 10px"
                                :items-per-page="5">
                                <template v-slot:expanded-item="{ headers, item }">
                                    <td :colspan="headers.length" style="margin: 0;padding: 5px;">
                                        <v-simple-table dense>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th>{{ $t('monitor.logbook.headers.lines') }}</th>
                                                        <th>{{ $t('monitor.logbook.headers.vehicles') }}</th>
                                                        <th>{{ $t('monitor.logbook.headers.trips') }}</th>
                                                        <th>{{ $t('monitor.logbook.headers.registeredBy') }}</th>
                                                        <th>{{ $t('monitor.logbook.headers.editedBy') }}</th>
                                                        <th>{{ $t('monitor.logbook.headers.editedAt') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{{ item.linhas }}</td>
                                                        <td>{{ item.veiculos }}</td>
                                                        <td>{{ item.viagens_controladores }}</td>
                                                        <td>{{ item.usuario_inclusao }}</td>
                                                        <td>{{ item.usuario_edicao }}</td>
                                                        <td>{{ item.dt_edicao }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </td>
                                </template>
                            </v-data-table>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog v-model="editViagemDialog" width="80%">
                <v-card>
                    <v-toolbar flat color="primary" dark style="margin-bottom: 30px;">
                        <v-toolbar-title>{{ $t('monitor.trip.edit') }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon @click="closeEditViagemDialog" dark>mdi-close</v-icon>
                    </v-toolbar>
                    <v-card-text>
                        <v-container>
                            <v-form ref="editViagemForm">
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="horarioChegada" :label="$t('monitor.trip.arrival')"
                                            type="time" outlined :rules="[horarioChegadaRules]"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="horarioSaida" :label="$t('monitor.trip.departure')"
                                            type="time" outlined :rules="[horarioSaidaRules]"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12">
                                        <v-select v-model="variante" :items="variantes" item-text="descricao"
                                            item-value="id_variante" label="VIA" outlined></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="4">
                                        <v-text-field v-model="roleta" :label="$t('monitor.trip.turnstile')"
                                            type="number" min="0" outlined :rules="[roletaRules]"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-text-field v-model="odometro" :label="$t('monitor.trip.odometer')"
                                            type="number" min="0" outlined :rules="[odometroRules]"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-checkbox :label="$t('monitor.trip.lastTrip')" v-model="isUltimaViagem"
                                            color="primary"></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn block color="primary" dark @click="auxiliarUpdateViagem" height="60px"
                            style="padding: 5px;">{{
                                $t('monitor.trip.edit') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="veiculoDialog" fullscreen>
                <v-card>
                    <v-toolbar flat color="primary" dark>
                        <v-toolbar-title>{{ $t('monitor.guide.title') }} {{ veiculoSelected?.numero_ordem
                            }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon @click="closeVeiculoDialog" dark>mdi-close</v-icon>
                    </v-toolbar>
                    <v-card-text>
                        <v-container style="margin-bottom: 20px;">
                            <v-card style="margin-bottom: 20px;">
                                <v-card-title>{{ $t('monitor.guide.guideNumber') }} {{ veiculoSelected?.numero_guia
                                    }}</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <strong>{{ $t('monitor.guide.vehicle') }} </strong>
                                            <span>{{ veiculoSelected?.numero_ordem }}</span>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <strong>{{ $t('monitor.guide.line') }} </strong>
                                            <span>{{ veiculoSelected?.nome_linha_guia }}</span>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <strong>{{ $t('monitor.guide.pickup') }} </strong>
                                            <span>{{ veiculoSelected?.dt_pegada }}</span>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <strong>{{ $t('monitor.guide.scaling') }} </strong>
                                            <span>{{ veiculoSelected?.escalonamento }}</span>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <strong>{{ $t('monitor.guide.shift') }} </strong>
                                            <span>{{ veiculoSelected?.turno }}</span>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <strong>{{ $t('monitor.guide.driver') }} </strong>
                                            <span>{{ veiculoSelected?.nome_motorista_guia }} ({{
                                                veiculoSelected?.matricula_motorista_guia }})</span>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <strong>{{ $t('monitor.guide.collector') }} </strong>
                                            <span>{{ veiculoSelected?.nome_cobrador_guia }} ({{
                                                veiculoSelected?.matricula_cobrador_guia }})</span>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <strong>{{ $t('monitor.guide.turnstile') }} </strong>
                                            <span>{{ veiculoSelected?.roleta }}</span>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <strong>{{ $t('monitor.guide.plateTime') }} </strong>
                                            <span>{{ tempoDePlacaTotal }}</span>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <strong>{{ $t('monitor.guide.trips') }} </strong>
                                            <span>{{ nViagens }}</span>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                            <v-form ref="viagemForm">
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="horarioChegada" :label="$t('monitor.trip.arrival')"
                                            type="time" outlined :rules="[horarioChegadaRules]"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field v-model="horarioSaida" :label="$t('monitor.trip.departure')"
                                            type="time" outlined :rules="[horarioSaidaRules]"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12">
                                        <v-select v-model="variante" :items="variantes" item-text="descricao"
                                            item-value="id_variante" label="VIA" outlined></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="4">
                                        <v-text-field v-model="roleta" :label="$t('monitor.trip.turnstile')"
                                            type="number" min="0" outlined :rules="[roletaRules]"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-text-field v-model="odometro" :label="$t('monitor.trip.odometer')"
                                            type="number" min="0" outlined :rules="[odometroRules]"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-checkbox :label="$t('monitor.trip.lastTrip')" v-model="isUltimaViagem"
                                            color="primary"></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-btn block color="primary" dark @click="auxiliarSalvarNovaViagem"
                                        height="60px">Salvar
                                        Nova Viagem</v-btn>
                                </v-row>
                            </v-form>
                        </v-container>
                        <v-data-table :headers="headersGuia" :items="viagensGuia" sort-by="dt_chegada" dense
                            class="elevation-7" locale="pt" :loading="loadingViagensGuia"
                            :loading-text="$t('monitor.map.loading')" :items-per-page="5" style="border-radius: 10px"
                            :item-class="getViagemStyle" @click:row="editViagem">
                            <template v-slot:item.actions="{ item }">
                                <v-icon dark small color="green" v-if="canEditViagem(item)">mdi-pencil</v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-container>
                <v-row>
                    <v-col cols="12" sm="2">
                        <v-btn small fab dark @click="showDrawer = !showDrawer" color="primary">
                            <v-icon color="white">mdi-chevron-right</v-icon></v-btn>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-btn dark color="primary" block rounded @click="tab = 1">{{ $t('monitor.map.mapButton')
                            }}</v-btn>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-btn dark color="primary" block rounded @click="tab = 2">{{ $t('monitor.map.tripsButton')
                            }}</v-btn>
                    </v-col>
                    <v-col cols="12" sm="2">
                        <v-btn small fab dark @click="openDiarioBordo" color="primary">
                            <v-icon color="white">mdi-notebook</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-container>

            <div id="mapContainer">
                <l-map ref="map" :zoom="zoom" :center="currentCenter" :minZoom="minZoom" :maxZoom="maxZoom"
                    @update:center="centerUpdate" @update:zoom="zoomUpdate" :options="mapOptions"
                    style="border-radius: 10px; margin-top: 5px; z-index: 1" v-if="tab === 1">
                    <l-tile-layer :url="url" :attribution="attribution" />

                    <l-control :position="'topright'" class="text-overlay" v-if="linhaSelected">
                        <strong>{{ linhaSelected.nome_rota_longo }}</strong>
                    </l-control>

                    <l-geo-json v-if="rotas" :geojson="rotas" :options-style="rotaOptionsStyle" />
                    <l-geo-json v-if="cercasMarkersFiltered" :geojson="cercasMarkersFiltered"
                        :options="markerOptions" />

                    <Vue2LeafletRotatedMarker v-for="(reg, v) in veiculosSelected" :key="`${reg.id_veiculo}-${v}`"
                        :lat-lng="latLng(reg.lat, reg.lng)" :icon="getIcon(reg)" :rotationAngle="parseInt(reg.rumo)"
                        :rotationOrigin="'15px 15px'">
                        <l-tooltip :content="reg.numero_ordem"
                            :options="{ permanent: true, direction: 'top', opacity: 1.0, className: 'veiculo__tooltip' }"></l-tooltip>
                    </Vue2LeafletRotatedMarker>

                    <Vue2LeafletRotatedMarker v-for="(reg, v) in veiculosSelectedSentidoInvalido"
                        :key="`${reg.id_veiculo}-${v}`" :lat-lng="latLng(reg.lat, reg.lng)" :icon="getIcon(reg)"
                        :rotationAngle="parseInt(reg.rumo)" :rotationOrigin="'15px 15px'">
                        <l-tooltip :content="reg.numero_ordem"
                            :options="{ permanent: true, direction: 'top', opacity: 1.0, className: 'veiculo__tooltip' }"></l-tooltip>
                    </Vue2LeafletRotatedMarker>
                </l-map>
                <v-data-table v-else :headers="headers" :items="viagensFiltered" :sort-by="['cod_linha', 'dt_saida']"
                    dense class="elevation-7" locale="pt" :loading="loading" :loading-text="$t('monitor.map.loading')"
                    :item-class="getViagemStyle" style="border-radius: 10px" @click:row="editViagem"></v-data-table>
            </div>
        </div>
    </div>
</template>

<script>
import apiController from "@/utils/apiController";
import L from "leaflet";
import { LMap, LTileLayer, LGeoJson, LTooltip, LControl } from "vue2-leaflet";
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker';
import "leaflet/dist/leaflet.css";
import DateUtils from '../utils/dateutils'
import { mapGetters, mapMutations } from "vuex";
import EventBus from "@/utils/eventBus";
import translateDbField from "@/utils/translateDbField";

export default {
    name: "MapaMonitor",
    components: {
        LMap,
        LTileLayer,
        LGeoJson,
        LTooltip,
        LControl,
        Vue2LeafletRotatedMarker
    },
    data: () => ({
        isMobile: true,
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        user: null,
        token: null,
        autorizacaoDialog: false,
        mensagemAutorizacaoDialog: "",
        dialogConfirmacaoRoletaQuebra: false,
        confirmacaoRoletaQuebraAceita: false,
        pendingRoletaQuebraSaveAction: null,
        config: null,
        zoom: 12,
        currentZoom: 11.5,
        currentCenter: null,
        mapOptions: {
            zoomSnap: 0.5,
        },
        map: null,
        minZoom: 5,
        maxZoom: 18,
        showDrawer: false,
        searchLinhas: "",
        rotas: null,
        cercas: [],
        cercasMarkers: [],
        linhas: [],
        linhasFiltered: [],
        veiculos: [],
        viagens: [],
        viagensGuia: [],
        variantes: [],
        recursos: [],
        pontos: [],
        pontoSelected: null,
        veiculoSelected: null,
        veiculoDialog: false,
        horarioChegada: null,
        horarioSaida: null,
        linhaSelected: null,
        editedItem: {
            id_viagem: null,
            dt_chegada: null,
            dt_saida: null,
            roleta: null,
            odometro: null,
            id_sentido: null,
            tempo_de_placa: null,
            passageiros: null,
            id_cerca: null,
            id_usuario: null,
            id_guia: null,
            id_linha: null,
            ultima_viagem: null,
            dt_ultima_alteracao: null,
            id_usuario_alteracao: null,
            dt_chegada_anterior: null,
            dt_saida_anterior: null,
            roleta_anterior: null,
            odometro_anterior: null,
            id_variante: null,
            descricao_variante: null,
        },
        defaultItem: {
            id_viagem: null,
            dt_chegada: null,
            dt_saida: null,
            roleta: null,
            odometro: null,
            id_sentido: null,
            tempo_de_placa: null,
            passageiros: null,
            id_cerca: null,
            id_usuario: null,
            id_guia: null,
            id_linha: null,
            ultima_viagem: null,
            dt_ultima_alteracao: null,
            id_usuario_alteracao: null,
            dt_chegada_anterior: null,
            dt_saida_anterior: null,
            roleta_anterior: null,
            odometro_anterior: null,
            id_variante: null,
            descricao_variante: null,
        },
        loading: false,
        loadingViagensGuia: false,
        tab: 1,
        tempoDePlacaTotal: null,
        nViagens: 0,
        roleta: null,
        odometro: null,
        variante: null,
        isUltimaViagem: false,
        editViagemDialog: false,
        editViagemForm: null,
        viagemIndex: null,
        editingViagem: false,
        dialogDiarioBordo: false,
        itemDiario: {
            id_tipo_entrada_diario: null,
            id_motivo: null,
            id_linha: null,
            id_veiculo: null,
            id_viagem: null,
            dt_entrada: null,
            id_usuario_inclusao: null,
            observacoes: null
        },
        defaultItemDiario: {
            id_tipo_entrada_diario: null,
            id_motivo: null,
            id_linha: null,
            id_veiculo: null,
            id_viagem: null,
            dt_entrada: null,
            id_usuario_inclusao: null,
            observacoes: null
        },
        entradasDiario: [],
        tiposEntradaDiario: [],
        motivos: [],
        dtEntradaDiario: null,
        loadingDiario: false,
        diarioForm: null,
        diarioLinhas: [],
        diarioVeiculos: [],
        diarioViagens: [],
        viagensDiarioDialog: [],
        timeProps: {
            useSeconds: true,
        },
    }),
    mounted() {
        this.map = this.$refs.map.mapObject;
        this.onResize()
        window.addEventListener('resize', this.onResize, { passive: true })
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaConfig();
        this.initialize();
    },
    computed: {
        ...mapGetters('timeout', {
            veiculosTimeout: 'veiculos',
        }),
        ...mapGetters('config', {
            center: 'centerDefault'
        }),
        today() {
            return new Date();
        },
        tomorrow() {
            let d = new Date();
            d.setDate(d.getDate() + 1);
            return d;
        },
        headersWithProperties() {
            return this.headers.map(header => ({
                ...header,
                filtrable: true,
                sortable: true
            }));
        },
        headersGuiaWithProperties() {
            return this.headersGuia.map(header => ({
                ...header,
                filtrable: true,
                sortable: true
            }));
        },
        headersDiarioWithProperties() {
            return this.headersDiario.map(header => ({
                ...header,
                filtrable: true,
                sortable: true
            }));
        },
        viagensFiltered() {
            if (this.linhaSelected) {
                let linha = this.linhaSelected;
                return this.viagens.filter((v) => v.id_linha === linha.id_linha && v.id_sentido === linha.id_sentido);
            }

            return this.viagens;
        },
        cercasMarkersFiltered() {
            if (this.linhaSelected) {
                let linha = this.linhaSelected;
                return this.cercasMarkers.filter((c) => c.properties.linha === linha.id_linha);
            }

            return null
        },
        markerOptions() {
            return {
                onEachFeature: function (feature, layer) {
                    if (feature.properties && feature.properties.popupContent) {
                        layer.bindPopup(feature.properties.popupContent);
                    }
                }
            }
        },
        rotaOptionsStyle() {
            return { color: "#1A237E" };
        },
        veiculosSelected() {
            if (!this.linhaSelected) {
                return [];
            } else {
                return this.veiculos.filter((v) => {
                    return v.id_linha_guia === this.linhaSelected.id_linha && v.sentido + 1 === this.linhaSelected.id_sentido;
                });
            }
        },
        veiculosSelectedSentidoInvalido() {
            if (!this.linhaSelected) {
                return [];
            } else {
                return this.veiculos.filter((v) => {
                    return v.id_linha_guia === this.linhaSelected.id_linha && v.sentido == 2;
                });
            }
        },
        roletaMaxima() {
            if (this.config) {
                return 10 ** this.config.numero_digitos_roleta - 1;
            }

            return 0;
        },
        roletaAnterior() {
            if (!this.veiculoSelected || !this.veiculoSelected?.roleta) {
                return this.editedItem.roleta;
            }

            if (this.viagensGuia.length > 0) {
                return this.viagensGuia[this.viagensGuia.length - 1].roleta;
            }

            return this.veiculoSelected.roleta;
        },
        headers() {
            return [
                { text: this.$t('monitor.trip.headers.tripId'), value: "id_viagem", align: " d-none" },
                { text: this.$t('monitor.trip.headers.line'), value: "cod_linha" },
                { text: "Via", value: "descricao_variante" },
                { text: this.$t('monitor.trip.headers.geofence'), value: "nome_cerca" },
                { text: this.$t('monitor.trip.headers.vehicle'), value: "numero_ordem" },
                { text: this.$t('monitor.trip.headers.arrival'), value: "dt_chegada_extenso" },
                { text: this.$t('monitor.trip.headers.departure'), value: "dt_saida_extenso" },
                { text: this.$t('monitor.trip.headers.plateTime'), value: "tempo_de_placa" },
                { text: this.$t('monitor.trip.headers.turnstile'), value: "roleta" },
                { text: this.$t('monitor.trip.headers.passengers'), value: "passageiros" }]
        },
        headersGuia() {
            return [
                { text: this.$t('monitor.trip.headers.tripId'), value: "id_viagem", align: " d-none" },
                { text: this.$t('monitor.trip.headers.arrival'), value: "dt_chegada_extenso" },
                { text: this.$t('monitor.trip.headers.departure'), value: "dt_saida_extenso" },
                { text: "Via", value: "descricao_variante" },
                { text: this.$t('monitor.trip.headers.plateTime'), value: "tempo_de_placa" },
                { text: this.$t('monitor.trip.headers.turnstile'), value: "roleta" },
                { text: this.$t('monitor.trip.headers.passengers'), value: "passageiros" },
                { text: "Ações", value: "actions", align: "center", sortable: false },
            ]
        },
        headersDiario() {
            return [
                { text: this.$t('monitor.logbook.headers.entryId'), value: "id_entrada_diario", align: " d-none" },
                { text: this.$t('monitor.logbook.headers.date'), value: "dt_entrada" },
                { text: this.$t('monitor.logbook.headers.type'), value: "descricao_tipo_entrada" },
                { text: this.$t('monitor.logbook.headers.reason'), value: "descricao_motivo" },
                { text: this.$t('monitor.logbook.headers.observations'), value: "observacoes" }]
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('monitor.logbook.selectDate')]
            }
        }
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
        }
    },
    methods: {
        ...mapMutations('timeout', [
            'resetVeiculos'
        ]),
        logout() {
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("api");
            var id = window.setTimeout(function () { }, 0);
            while (id--) {
                window.clearTimeout(id); // will do nothing if no timeout with id is present
            }
            this.$router.push({ path: "/" });
        },
        onResize() {
            this.isMobile = window.matchMedia('(max-width: 1000px)').matches;
        },
        initialize() {
            this.currentCenter = this.center;
            this.populaRecursos();
        },

        fechaViagemGrid() {
            let viagemAFechar = {
                horario_chegada_controlador: this.editedItem.dt_chegada,
                id_usuario_fechamento_controlador: this.user.id_usuario,
                id_viagem_grid: this.veiculoSelected.id_viagem_grid_controlador
            }
            apiController.request(apiController.endpoints.fechaviagemgridcontrolador, {
                data: viagemAFechar,
                silent: true,
                onSuccess: () => {
                    console.log("Viagem fechada com sucesso no grid");
                },
                onError: (e) => {
                    console.log("Erro ao fechar viagem no grid");
                    console.log(e);
                },
            });
        },
        populaVariantes() {
            apiController.request(apiController.endpoints.getVariantesporlinha, {
                params: { idlinha: this.linhaSelected.id_linha },
                silent: true,
                onSuccess: (response) => {
                    this.variantes = response.data.filter((v) => v.id_cerca_inicio === this.pontoSelected.id_cerca);
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                },
                onError: (e) => {
                    console.log(this.$t('system.messages.errorAxios'));
                    console.log(e.message);
                },
            });
        },
        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.populaPontos();
                    },
                    onError: (e) => {
                        console.log("Response : " + e.message);
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    silent: true,
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.populaPontos();
                    },
                    onError: (e) => {
                        console.log("Response : " + e.message);
                        if (e.message == "Request failed with status code 401") {
                            this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                            this.autorizacaoDialog = true;
                        }
                    },
                });
            }
        },
        populaPontos() {
            apiController.request(apiController.endpoints.getallCercasativas, {
                silent: true,
                onSuccess: (response) => {
                    this.pontos = response.data;
                    this.populaLinhas();
                    this.populaVeiculos();
                    this.populaViagens();
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaLinhas() {
            if (this.pontos.length > 0) {
                apiController.request(apiController.endpoints.getLinhasporpontosiniciaisefinais, {
                    data: this.pontos.map((p) => p.id_cerca),
                    onSuccess: (response) => {
                        this.linhas = response.data;
                        this.populaCercas();
                    },
                    onError: (e) => {
                        console.log("Response : " + e.message);
                    },
                });
            }
        },
        populaVeiculos() {
            if (this.pontos.length > 0) {
                apiController.request(apiController.endpoints.getallVeiculosativos, {
                    onSuccess: (response) => {
                        this.veiculos = response.data;
                        this.resetVeiculos(setTimeout(() => this.populaVeiculos(), 30000));
                    },
                    onError: (e) => {
                        console.log("Response : " + e.message);
                    },
                });
            }
        },
        populaCercas() {
            if (this.pontos.length > 0) {
                let temp = this.linhas.map((l) => l.id_linha);
                apiController.request(apiController.endpoints.getCercasporlinha, {
                    data: temp,
                    onSuccess: (response) => {
                        this.cercas = response.data;
                        this.populaCercasMarkers();
                    },
                    onError: (e) => {
                        console.log("Response : " + e.message);
                    },
                });
            }
        },
        populaCercasMarkers() {
            this.cercasMarkers = this.cercas.map((c) => {
                return {
                    type: "Feature",
                    properties: {
                        name: c.nome_cerca,
                        linha: c.id_linha,
                        popupContent: c.nome_cerca
                    },
                    geometry: {
                        type: "Point",
                        coordinates: [c.lng_centro, c.lat_centro]
                    }
                }
            });
        },
        populaViagens() {
            this.loadingViagensGuia = true;
            this.loading = true;
            let dti = DateUtils.getDateSQLFormatted(this.today).substring(0,8) + "T03:00:00";
            let dtf = DateUtils.getDateSQLFormatted(this.tomorrow).substring(0,8) + "T02:59:59";
            let body = {
                dti: dti,
                dtf: dtf,
                idcercas: this.pontos.map((p) => p.id_cerca)
            };

            if (this.pontos.length > 0) {
                apiController.request(apiController.endpoints.getViagenscontroladoresdatacerca, {
                    data: body,
                    onSuccess: (response) => {
                        this.viagens = response.data;
                        if (this.veiculoSelected) {
                            let veiculo = this.veiculoSelected;
                            this.viagensGuia = this.viagens.filter((v) => v.id_veiculo === veiculo.id_veiculo && v.id_guia === veiculo.id_guia);
                            let placa = 0;
                            this.viagensGuia.forEach((v) => {
                                let [hours, minutes] = v.tempo_de_placa.split(":");
                                placa += parseInt(hours) * 60 + parseInt(minutes);
                            });
                            let hours = Math.floor(placa / 60);
                            let minutes = placa % 60;
                            this.tempoDePlacaTotal = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
                            this.nViagens = this.viagensGuia.length;
                        }
                        this.loading = false;
                        this.loadingViagensGuia = false;
                    },
                    onError: (e) => {
                        this.loading = false;
                        this.loadingViagensGuia = false;
                        console.log("Response : " + e.message);
                    },
                });
            }
        },
        updateRoleta() {
            let body = {
                roleta: this.editedItem.roleta,
                idveiculo: this.editedItem.id_veiculo
            };

            apiController.request(apiController.endpoints.updateRoleta, {
                data: body,
                silent: true,
                onSuccess: () => {
                    if (this.veiculoSelected) {
                        this.veiculoSelected.roleta = this.editedItem.roleta;
                    }
                },
                onError: (e) => {
                    console.log("Response : " + e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        horarioChegadaRules() {
            if (!this.horarioChegada) {
                return this.$t('monitor.trip.arrivalRequired');
            }

            if (this.horarioSaida && this.horarioSaida < this.horarioChegada) {
                return this.$t('monitor.trip.departureAfterArrival');
            }

            return true;
        },
        horarioSaidaRules() {
            if (!this.horarioSaida && !this.isUltimaViagem) {
                return "Horário de saída é obrigatório";
            }

            if (this.horarioChegada && this.horarioSaida < this.horarioChegada) {
                return this.$t('monitor.trip.departureAfterArrival');
            }

            return true;
        },
        confirmarInclusaoRoletaQuebra() {
            this.confirmacaoRoletaQuebraAceita = true;
            this.dialogConfirmacaoRoletaQuebra = false;
            const action = this.pendingRoletaQuebraSaveAction;
            this.pendingRoletaQuebraSaveAction = null;
            if (action === "nova") {
                this.saveNovaViagem();
            } else if (action === "edit") {
                this.updateViagem();
            }
        },
        cancelarConfirmacaoRoletaQuebra() {
            this.dialogConfirmacaoRoletaQuebra = false;
            this.pendingRoletaQuebraSaveAction = null;
            this.confirmacaoRoletaQuebraAceita = false;
        },
        /** Roleta atual maior que a anterior em pelo menos config.porcentagem_diferenca_roleta % (mesma regra do roleteiro, com filtros de roleta ativos). */
        precisaConfirmarRoletaQuebra(atual, anterior) {
            if (this.config?.ligar_filtros_roleta != 1) {
                return false;
            }
            const pct = Number(this.config?.porcentagem_diferenca_roleta);
            if (!pct || pct <= 0) {
                return false;
            }
            const a = Number(atual);
            const ant = Number(anterior);
            if (!Number.isFinite(a) || !Number.isFinite(ant) || ant <= 0) {
                return false;
            }
            if (a <= ant) {
                return false;
            }
            return ((a - ant) / ant) * 100 >= pct;
        },
        auxiliarSalvarNovaViagem() {
            if (!this.$refs.viagemForm.validate()) {
                return;
            }
            const atual = parseInt(this.roleta, 10);
            const anterior =
                this.roletaAnterior != null && this.roletaAnterior !== ""
                    ? Number(this.roletaAnterior)
                    : null;
            if (
                !this.confirmacaoRoletaQuebraAceita &&
                this.precisaConfirmarRoletaQuebra(atual, anterior)
            ) {
                this.pendingRoletaQuebraSaveAction = "nova";
                this.dialogConfirmacaoRoletaQuebra = true;
                return;
            }
            this.confirmacaoRoletaQuebraAceita = false;
            this.saveNovaViagem();
        },
        auxiliarUpdateViagem() {
            if (!this.$refs.editViagemForm.validate()) {
                return;
            }
            const atual = parseInt(this.roleta, 10);
            const anterior =
                this.roletaAnterior != null && this.roletaAnterior !== ""
                    ? Number(this.roletaAnterior)
                    : null;
            if (
                !this.confirmacaoRoletaQuebraAceita &&
                this.precisaConfirmarRoletaQuebra(atual, anterior)
            ) {
                this.pendingRoletaQuebraSaveAction = "edit";
                this.dialogConfirmacaoRoletaQuebra = true;
                return;
            }
            this.confirmacaoRoletaQuebraAceita = false;
            this.updateViagem();
        },
        roletaRules() {
            if ((this.isUltimaViagem || this.config.monitor_roleta_obrigatoria) && !this.roleta) {
                return this.$t('monitor.trip.turnstileRequired');
            }

            if (this.roleta) {
                if (this.roleta > this.roletaMaxima) {
                    return `Roleta não pode ser maior que ${this.roletaMaxima}`;
                }

                if (this.roletaAnterior) {
                    if (this.roleta < this.roletaAnterior) {
                        if (this.config?.porcentagem_diferenca_roleta) {
                            return true;
                        }
                        return "Roleta atual não pode ser menor que a anterior";
                    }
                }

                return true;

            }

            return true;
        },
        odometroRules() {
            if (this.config.monitor_odometro_obrigatorio && !this.odometro) {
                return this.$t('monitor.trip.odometerRequired');
            }

            return true;
        },
        pontoChanged() {
            let ponto = this.pontoSelected;
            if (ponto) {
                this.linhasFiltered = this.linhas.filter((l) => l.ponto_inicial == ponto.id_cerca || l.ponto_final == ponto.id_cerca);
                this.currentCenter = [ponto.lat_centro, ponto.lng_centro];
            } else {
                this.linhasFiltered = [];
            }
        },
        zoomUpdate(zoom) {
            this.currentZoom = zoom;
        },
        centerUpdate(center) {
            this.currentCenter = center;
        },
        onMapPlotagemResize() {
            this.$refs.mapPlotagem.mapObject.invalidateSize();
        },
        latLng: function (lat, lng) {
            if (lat != null && lng !== null) {
                if (lat.trim() !== "0") {
                    return L.latLng(lat, lng);
                } else {
                    return L.latLng(-22.88746, -43.29185);
                }
            } else {
                return L.latLng(-22.88746, -43.29185);
            }
        },
        getIcon(veiculo) {
            let color = "none";
            let title = this.$t('monitor.map.gpsAndValidatorOnline')
            let width = "0";
            let height = "0";
            let classname = "my-custom-pin";
            if (veiculo.validador_offline === 1) {
                color = "red";
                title = `${veiculo.numero_ordem}: ${this.$t('operationSummary.totalValidatorOffline')}`;
            }

            if (veiculo.gps_offline === 1) {
                classname += " blink";
            }

            if (veiculo.validador_offline === 0) {

                if (!veiculo.id_guia) {
                    color = "red";
                    title = `${veiculo.numero_ordem}: ${this.$t('operation.noGuide')}`;
                } else {
                    if (veiculo.sentido === 0) {
                        color = "#008000";
                    } else if (veiculo.sentido === 1) {
                        color = "#FF5722";
                    } else {
                        color = "#607D8B";
                    }
                }

            }

            // if (veiculo.gps_offline === 1 && veiculo.validador_offline === 0) {
            //   color = "#FFA500";
            //   title = "GPS Offline"
            // }

            if (this.veiculoClicked?.id_veiculo === veiculo.id_veiculo) {
                width = "40";
                height = "40";
            } else {
                width = "30";
                height = "30";
            }

            return L.divIcon({
                className: classname,
                html: `<svg width="${width}" height="${height}" viewBox="0 0 24 24" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg"><title>${title}</title>
                        <path opacity="0.1" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" fill="${color}"/>
                        <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="${color}" stroke-width="2"/>
                        <path d="M15 13L12.2014 10.2014V10.2014C12.0901 10.0901 11.9099 10.0901 11.7986 10.2014V10.2014L9 13" stroke="${color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>`,
                itemAnchor: [15, 15]
            });

        },
        plotOnMap(linha) {
            if (!this.linhaSelected || this.linhaSelected.id_rota !== linha.id_rota) {
                this.linhaSelected = linha;
            } else {
                this.linhaSelected = null;
            }

            if (!this.linhaSelected) {
                this.rotas = null;
            } else {
                this.rotas = JSON.parse(linha.geojson);
            }
        },
        openVeiculoDialog(veiculo) {
            this.loadingViagensGuia = true;
            this.veiculoSelected = Object.assign({}, veiculo);
            this.editedItem.id_linha = veiculo.id_linha_guia || veiculo.id_linha;
            this.editedItem.id_guia = veiculo.id_guia;
            this.editedItem.id_usuario = this.user.id_usuario;
            this.editedItem.id_cerca = this.pontoSelected.id_cerca;
            this.editedItem.id_veiculo = veiculo.id_veiculo;
            this.veiculoDialog = true;
            this.viagensGuia = this.viagens.filter((v) => v.id_veiculo === veiculo.id_veiculo && v.id_guia === veiculo.id_guia);
            this.populaVariantes();

            let placa = 0
            this.viagensGuia.forEach((v) => {
                let [hours, minutes] = v.tempo_de_placa.split(":");
                placa += parseInt(hours) * 60 + parseInt(minutes);
            });
            let hours = Math.floor(placa / 60);
            let minutes = placa % 60;
            this.tempoDePlacaTotal = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
            this.nViagens = this.viagensGuia.length;
            this.loadingViagensGuia = false;
        },
        closeVeiculoDialog() {
            this.veiculoDialog = false;
            this.dialogConfirmacaoRoletaQuebra = false;
            this.pendingRoletaQuebraSaveAction = null;
            this.confirmacaoRoletaQuebraAceita = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.viagensGuia = [];
                this.variantes = [];
                this.tempoDePlacaTotal = null;
                this.nViagens = null;
                this.horarioChegada = null;
                this.horarioSaida = null;
                this.roleta = null;
                this.odometro = null;
                this.veiculoSelected = null;
                this.isUltimaViagem = false;
            });
        },
        calculaPassageiros(atual, anterior) {
            console.log(atual, anterior);
            if (atual >= anterior) {
                console.log('atual >= anterior');
                return atual - anterior;
            }

            console.log('atual < anterior');
            console.log(this.roletaMaxima - anterior + atual);
            return this.roletaMaxima - anterior + atual;
        },
        saveNovaViagem() {
            if (this.$refs.viagemForm.validate()) {
                this.loadingViagensGuia = true;
                this.editedItem.dt_saida = this.horarioSaida ? DateUtils.getDateSQLFormatted(this.today).substring(0, 8) + this.horarioSaida.replaceAll(":", "") + "00" : null;
                this.editedItem.dt_chegada = this.horarioChegada ? DateUtils.getDateSQLFormatted(this.today).substring(0, 8) + this.horarioChegada.replaceAll(":", "") + "00" : this.editedItem.dt_saida;
                this.editedItem.id_sentido = this.linhas.find((l) => this.editedItem.id_linha === l.id_linha).ponto_inicial === this.editedItem.id_cerca ? 1 : 2;
                this.editedItem.roleta = parseInt(this.roleta);
                this.editedItem.odometro = this.odometro;
                this.editedItem.passageiros = this.calculaPassageiros(parseInt(this.roleta), this.roletaAnterior);
                this.editedItem.ultima_viagem = this.isUltimaViagem ? 1 : 0;
                this.editedItem.id_variante = this.variante;
                apiController.request(apiController.endpoints.insertViagemcontrolador, {
                    data: this.editedItem,
                    silent: true,
                    onSuccess: () => {
                        this.confirmacaoRoletaQuebraAceita = false;
                        if (this.editedItem.dt_chegada && this.veiculoSelected.id_viagem_grid_controlador) {
                            this.fechaViagemGrid();
                        }
                        this.populaViagens();
                        this.updateRoleta();
                        this.horarioChegada = null;
                        this.horarioSaida = null;
                        this.roleta = null;
                        this.odometro = null;
                        this.isUltimaViagem = false;
                        this.variante = null;
                        this.$refs.viagemForm.resetValidation();
                    },
                    onError: (e) => {
                        this.confirmacaoRoletaQuebraAceita = false;
                        this.loadingViagensGuia = false;
                        console.log("Response : " + e.message);
                        if (e.message == "Request failed with status code 401") {
                            this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                            this.autorizacaoDialog = true;
                        }
                    },
                });
            }
        },
        getViagemStyle(item) {
            if (this.pontoSelected) {
                let item_class = item.id_cerca == this.pontoSelected.id_cerca ? 'ponto__atual' : 'outro__ponto';
                return item_class;
            }

            return null;
        },
        canEditViagem(viagem) {
            return viagem.id_cerca == this.pontoSelected.id_cerca && this.viagensGuia.findIndex((v) => v.id_viagem === viagem.id_viagem) === this.viagensGuia.length - 1
        },
        editViagem(viagem) {
            if (this.canEditViagem(viagem)) {
                this.editedItem = Object.assign({}, viagem);
                this.horarioChegada = this.editedItem.dt_chegada_extenso;
                this.horarioSaida = this.editedItem.dt_saida_extenso;
                this.roleta = this.editedItem.roleta;
                this.odometro = this.editedItem.odometro;
                this.isUltimaViagem = this.editedItem.ultima_viagem;
                if (this.viagensGuia.length === 0) {
                    this.viagensGuia = this.viagens.filter((v) => v.id_guia === this.editedItem.id_guia);
                }
                this.editViagemDialog = true;
                this.editingViagem = true;
            }
        },
        updateViagem() {
            if (this.$refs.editViagemForm.validate()) {
                let dtChegada = DateUtils.getDateSQLFormatted(this.today).substring(0, 8) + this.horarioChegada.replaceAll(":", "") + "00";
                if (this.editedItem.dt_chegada !== dtChegada) {
                    this.editedItem.dt_chegada_anterior = this.editedItem.dt_chegada;
                    this.editedItem.dt_chegada = dtChegada;
                }

                let dtSaida = DateUtils.getDateSQLFormatted(this.today).substring(0, 8) + this.horarioSaida.replaceAll(":", "") + "00";
                if (this.editedItem.dt_saida !== dtSaida) {
                    this.editedItem.dt_saida_anterior = this.editedItem.dt_saida;
                    this.editedItem.dt_saida = dtSaida;
                }

                if (this.editedItem.roleta !== this.roleta) {
                    this.editedItem.roleta_anterior = this.editedItem.roleta;
                    this.editedItem.roleta = this.roleta;
                    this.editedItem.passageiros = this.calculaPassageiros(parseInt(this.roleta), this.roletaAnterior);
                }

                if (this.editedItem.odometro !== this.odometro) {
                    this.editedItem.odometro_anterior = this.editedItem.odometro;
                    this.editedItem.odometro = this.odometro;
                }

                this.editedItem.ultima_viagem = this.isUltimaViagem ? 1 : 0;
                this.editedItem.id_usuario_alteracao = this.user.id_usuario;

                apiController.request(apiController.endpoints.updateViagemcontrolador, {
                    data: this.editedItem,
                    silent: true,
                    onSuccess: () => {
                        this.confirmacaoRoletaQuebraAceita = false;
                        if (this.editedItem.dt_chegada && this.veiculoSelected.id_viagem_grid_controlador) {
                            this.fechaViagemGrid();
                        }
                        this.populaViagens();
                        this.updateRoleta();
                        this.closeEditViagemDialog();
                    },
                    onError: (e) => {
                        this.confirmacaoRoletaQuebraAceita = false;
                        console.log("Response : " + e.message);
                        if (e.message == "Request failed with status code 401") {
                            this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                            this.autorizacaoDialog = true;
                        }
                    },
                });
            }
        },
        closeEditViagemDialog() {
            this.dialogConfirmacaoRoletaQuebra = false;
            this.pendingRoletaQuebraSaveAction = null;
            this.confirmacaoRoletaQuebraAceita = false;
            this.editedItem = Object.assign({}, this.defaultItem);
            this.horarioChegada = null;
            this.horarioSaida = null;
            this.roleta = null;
            this.odometro = null;
            this.isUltimaViagem = false;
            this.$refs.editViagemForm.resetValidation();
            if (this.$refs.editViagemForm) {
                this.$refs.viagemForm.resetValidation();
            }
            this.editViagemDialog = false;
            this.editingViagem = false;
        },
        populaTiposEntrada() {
            apiController.request(apiController.endpoints.getallTiposentrada, {
                silent: true,
                onSuccess: (response) => {
                    this.tiposEntradaDiario = response.data
                    this.tiposEntradaDiario.forEach(tipo => {
                        tipo.descricao_tipo_entrada = translateDbField(
                            tipo.translation_key,
                            tipo.descricao_tipo_entrada
                        );
                        return tipo;
                    });
                },
                onError: (e) => {
                    console.log(this.$t('system.messages.errorAxios'));
                    console.log(e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog =
                            this.$t('system.messages.accessDenied');
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaMotivos() {
            apiController.request(apiController.endpoints.getallMotivos, {
                silent: true,
                onSuccess: (response) => {
                    this.motivos = response.data
                },
                onError: (e) => {
                    console.log(this.$t('system.messages.errorAxios'));
                    console.log(e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog =
                            this.$t('system.messages.accessDenied');
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        populaEntradasDiario() {
            this.loadingDiario = true;
            let today = DateUtils.getDateSQLFormatted(new Date());
            let dataInicial = today.substring(0, 8) + "000000";
            let dataFinal = today;

            let body = {
                dti: dataInicial,
                dtf: dataFinal,
                idlinhas: null,
                idveiculos: null,
                idviagensprevistas: null,
                idviagensrealizadas: null,
                idviagenscontroladores: null,
            }

            apiController.request(apiController.endpoints.getEntradaspordata, {
                data: body,
                silent: true,
                onSuccess: (response) => {
                    this.entradasDiario = response.data;
                    this.entradasDiario.forEach(entrada => {
                        entrada.descricao_tipo_entrada = translateDbField(
                            entrada.translation_key_tipo_entrada,
                            entrada.descricao_tipo_entrada
                        );
                        return entrada;
                    });
                    this.loadingDiario = false;
                },
                onError: (e) => {
                    this.loadingDiario = false;
                    console.log(this.$t('system.messages.errorAxios'));
                    console.log(e.message);
                    if (e.message == "Request failed with status code 401") {
                        this.mensagemAutorizacaoDialog =
                            this.$t('system.messages.accessDenied');
                        this.autorizacaoDialog = true;
                    }
                },
            });
        },
        openDiarioBordo() {
            this.dtEntradaDiario = this.today;
            this.populaMotivos();
            this.populaTiposEntrada();
            this.populaEntradasDiario();
            this.viagensDiarioDialog = this.viagens.filter((v) => v.id_cerca === this.pontoSelected.id_cerca);
            this.dialogDiarioBordo = true;
        },
        closeDiarioBordo() {
            this.$refs.diarioForm.resetValidation();
            this.itemDiario = Object.assign({}, this.defaultItemDiario);
            this.diarioLinhas = [];
            this.diarioVeiculos = [];
            this.diarioViagens = [];
            this.dialogDiarioBordo = false;
        },
        saveEntrada() {
            if (this.$refs.diarioForm.validate()) {
                this.itemDiario.dt_entrada = DateUtils.getDateSQLFormatted(this.dtEntradaDiario);
                this.itemDiario.id_usuario_inclusao = this.user.id_usuario;

                apiController.request(apiController.endpoints.insertEntrada, {
                    data: this.itemDiario,
                    silent: true,
                    onSuccess: (response) => {
                        this.saveLinhasEntrada(response.data.insertId);
                    },
                    onError: (e) => {
                        console.log(this.$t('system.messages.errorAxios'));
                        console.log(e.message);
                        EventBus.$emit('show-alert', {
                            tipo: 'error',
                            mensagem: e.message
                        });
                        if (e.message == "Request failed with status code 401") {
                            this.mensagemAutorizacaoDialog =
                                this.$t('system.messages.accessDenied');
                            this.autorizacaoDialog = true;
                        }
                    },
                });
            }
        },
        saveLinhasEntrada(idEntrada) {
            if (this.diarioLinhas.length > 0) {
                let temp = this.diarioLinhas.map((e) => {
                    return [idEntrada, e];
                });

                apiController.request(apiController.endpoints.insertLinhasentradabulk, {
                    data: temp,
                    silent: true,
                    onSuccess: () => {
                        this.saveVeiculosEntrada(idEntrada);
                    },
                    onError: (e) => {
                        console.log(this.$t('system.messages.errorAxios'));
                        console.log(e.message);
                        EventBus.$emit('show-alert', {
                            tipo: 'error',
                            mensagem: e.message
                        });
                        if (e.message == "Request failed with status code 401") {
                            this.mensagemAutorizacaoDialog =
                                this.$t('system.messages.accessDenied');
                            this.autorizacaoDialog = true;
                        }
                    },
                });
            } else {
                this.saveVeiculosEntrada(idEntrada);
            }
        },
        saveVeiculosEntrada(idEntrada) {
            if (this.diarioVeiculos.length > 0) {
                let temp = this.diarioVeiculos.map((e) => {
                    return [idEntrada, e];
                });

                apiController.request(apiController.endpoints.insertVeiculosentradabulk, {
                    data: temp,
                    silent: true,
                    onSuccess: () => {
                        this.saveViagensEntrada(idEntrada);
                    },
                    onError: (e) => {
                        console.log(this.$t('system.messages.errorAxios'));
                        console.log(e.message);
                        EventBus.$emit('show-alert', {
                            tipo: 'error',
                            mensagem: e.message
                        });
                    },
                });
            } else {
                this.saveViagensEntrada(idEntrada);
            }
        },
        saveViagensEntrada(idEntrada) {
            if (this.diarioViagens.length > 0) {
                let temp = this.diarioViagens.map((e) => {
                    return [idEntrada, e];
                });

                apiController.request(apiController.endpoints.insertViagenscontroladoresentradabulk, {
                    data: temp,
                    silent: true,
                    onSuccess: () => {
                        EventBus.$emit('show-alert', {
                            tipo: 'success',
                            mensagem: this.$t('monitor.logbook.entrySuccess')
                        });
                        this.itemDiario = Object.assign({}, this.defaultItemDiario);
                        this.diarioLinhas = [];
                        this.diarioVeiculos = [];
                        this.diarioViagens = [];
                        this.$refs.diarioForm.resetValidation();
                        this.populaEntradasDiario();
                    },
                    onError: (e) => {
                        console.log(this.$t('system.messages.errorAxios'));
                        console.log(e.message);
                        EventBus.$emit('show-alert', {
                            tipo: 'error',
                            mensagem: e.message
                        });
                    },
                });
            } else {
                EventBus.$emit('show-alert', {
                    tipo: 'success',
                    mensagem: this.$t('monitor.logbook.entrySuccess')
                });
                this.itemDiario = Object.assign({}, this.defaultItemDiario);
                this.$refs.diarioForm.resetValidation();
                this.populaEntradasDiario();
            }
        },
        onLinhaDiarioChanged() {
            if (this.diarioLinhas.length > 0) {
                this.viagensDiarioDialog = this.viagensDiarioDialog.filter((v) => this.diarioLinhas.includes(v.id_linha));
            } else {
                this.viagensDiarioDialog = this.viagens.filter((v) => v.id_cerca === this.pontoSelected.id_cerca);
                this.diarioVeiculos = [];
            }
        },
        onVeiculoDiarioChanged() {
            if (this.diarioVeiculos.length > 0) {
                this.viagensDiarioDialog = this.viagensDiarioDialog.filter((v) => this.diarioVeiculos.includes(v.id_veiculo));
            } else {
                this.viagensDiarioDialog = this.viagens.filter((v) => v.id_cerca === this.pontoSelected.id_cerca);
                this.onLinhaDiarioChanged();
            }
        },
    }
}

</script>

<style scoped>
#mapContainer {
    width: 100%;
    height: calc(100vh - 130px);
}
</style>

<style>
.ponto__atual {
    background-color: rgba(0, 162, 255, 0.568) !important;
}

.outro__ponto {
    background-color: rgba(209, 60, 1, 0.692) !important;
}
</style>